/* src/app/views/area-publica/home-page/mapa-brasil/mapa-brasil.component.scss */
.label-projetos {
  font-family: "Alegreya Sans Regular";
}
.contador-projetos {
  font-family: "Alegreya Sans ExtraBold";
}
.nome-regiao {
  font-family: "Alegreya Sans ExtraBold";
}
.estado {
  cursor: pointer;
  fill: transparent;
}
.regiao-zooming {
  stroke-opacity: 1;
  stroke: #FFFFFF;
}
/*# sourceMappingURL=mapa-brasil.component.css.map */
